import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "@/components/ui/alert-dialog";

interface CreditConfirmDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onConfirm: () => void;
  credits: number;
  featureName: string;
  loading?: boolean;
  isPremiumFeature?: boolean;
}

export const CreditConfirmDialog = ({
  open,
  onOpenChange,
  onConfirm,
  credits,
  featureName,
  loading = false,
  isPremiumFeature = false
}: CreditConfirmDialogProps) => {
  return (
    <AlertDialog open={open} onOpenChange={onOpenChange}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>
            {isPremiumFeature ? '✨ Premium Feature' : 'Confirm Credit Usage'}
          </AlertDialogTitle>
          <AlertDialogDescription className="space-y-3">
            <p>
              <span className="font-semibold">{featureName}</span> will use{' '}
              <span className="font-bold text-primary">{credits} credit{credits > 1 ? 's' : ''}</span>.
            </p>
            {isPremiumFeature && (
              <div className="rounded-lg bg-primary/10 p-3 text-sm">
                <p className="font-semibold text-primary">Premium Feature</p>
                <p className="text-muted-foreground mt-1">
                  This advanced feature uses more credits but provides enhanced AI-powered insights.
                </p>
              </div>
            )}
            <p className="text-sm text-muted-foreground">
              Do you want to continue?
            </p>
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel disabled={loading}>Cancel</AlertDialogCancel>
          <AlertDialogAction onClick={onConfirm} disabled={loading}>
            {loading ? 'Processing...' : `Use ${credits} Credit${credits > 1 ? 's' : ''}`}
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
};
